<template>
  <div>
    <div class="flex flex-wrap items-center justify-between pb-4 py-1">
      <div class="flex items-center space-x-4">
        <div class="relative flex">
          <input
            type="text"
            v-model="searchQuery"
            id="table-search"
            class="px-4 py-2 text-gray-900 border border-gray-300 rounded-sm dark:border-gray-300 dark:placeholder-gray-400"
            placeholder="Search Department"
          />
          <button
            @click="triggerSearch"
            class="bg-custom-yellow text-white rounded-r px-2 md:px-3 py-0 md:py-1"
          >
            <svg
              class="w-6 h-6 text-gray-100 dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-width="2"
                d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
              />
            </svg>
          </button>
        </div>
      </div>

      <!-- Removed Add Service button - now available within department pages -->
    </div>

    <component
      :is="currentTabComponent"
      ref="currentTabComponent"
      :search-query="searchQuery"
    ></component>
  </div>
</template>

<script>
import FacilityServicesTab from "../tabs/FacilityServicesTab.vue";

export default {
  name: "FacilityServicesDashboard",
  components: {
    FacilityServicesTab,
  },
  data() {
    return {
      currentTab: "facility-services",
      searchQuery: "",
      showLoader: false,
      isDropdownVisible: false,
      selectedFilter: "idNumber",
    };
  },
  computed: {
    currentTabComponent() {
      switch (this.currentTab) {
        case "facility-services":
          return "FacilityServicesTab";
        default:
          return "FacilityServicesTab";
      }
    },
  },
  methods: {
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },

    applyFilter(option) {
      this.selectedFilter = option;
      this.isDropdownVisible = false;
    },

    triggerSearch() {
      const params = {
        name: this.searchQuery,
      };
      this.$refs.currentTabComponent.searchFacilityServices(params);
    },
  },
};
</script>

<style lang="css" scoped>
.bg-custom-yellow {
  background-color: #f59e0b;
}
</style>